import React from 'react';

import { ImageBlockCMS } from 'utils/sharedStrapiQueries/sharedTypes';

import * as S from './ArticleImageBlock.styles';

export interface ArticleImageBlockProps {
  data: ImageBlockCMS;
}

const defaultProps: Partial<ArticleImageBlockProps> = {};

const ArticleImageBlock: React.FunctionComponent<ArticleImageBlockProps> = ({
  data,
  ...rest
}) => {
  return <S.ArticleImageBlockWrapper src={data.image.url} {...rest} />;
};

ArticleImageBlock.defaultProps = defaultProps;

export default ArticleImageBlock;
